// _PP_ stands for ProductPackage

/**
 CGP SDK components should handle only CTAs which are form the relevant Product Package ID as follows:

 1. External Link component will handle CTAs from:

 	a. My Account Product Package ID – 10

 	b. Pending Application Product Package ID – 27

 	c. Membership Product Package ID – 14

 	d. Change Password Product Package ID - 15

 	e. Redeem Comp Points Product Package ID - 75

 2. RICH component will handle CTAs from:

 	a. RICH Page Product Package ID – 102

 	b. Races Widget Product Package ID – 101

 3. Messages component will handle CTAs from OMG Product Package ID – 76

 Additional Comment:
 If there it's required that the Race Tab will handle CTAs from Race Schedule Page and from the Race Leader board, the Race Tab component should handle CTAs from originProductPackageID=10 (MayAccount) When originDeepLinkID = 14\15.
 this also means that External Link component should not handle these CTAs in this case.
 */

export const PRODUCT_PACKAGE_MAP = {
	MY_ACCOUNT_PP_ID: 10,
	MEMBERSHIP_PP_ID: 14,
	CHANGE_PASSWORD_PP_ID: 15,
	PENDING_APPLICATION_PP_ID: 27,
	REDEEM_COMP_POINTS_PP_ID: 75,
	OMG_PP_ID: 76,
	RICH_PP_ID: 102
};


export const DEEP_LINK_MAP = {
    MY_ACCOUNT_DL_RESPONSIBLE_GAMING: 1,
	MY_ACCOUNT_DL_CHANGE_PASSWORD: 2,
    MY_ACCOUNT_DL_BONUSES: 3,
    MY_ACCOUNT_DL_PERSONAL_DETAILS: 4,
    MY_ACCOUNT_DL_INVITE_FRIEND: 5,
    MY_ACCOUNT_DL_REPORTS: 6,
    MY_ACCOUNT_DL_LC_CHALLENGES: 7,
    MY_ACCOUNT_DL_LC_REDEMPTION: 8,
    MY_ACCOUNT_DL_TOURNAMENT: 10,
    MY_ACCOUNT_DL_FREE_PLAY: 11,
    MY_ACCOUNT_DL_FREE_BETS: 12,
    MY_ACCOUNT_DL_COMP_POINTS: 13,
    MY_ACCOUNT_DL_MY_CHALLENGES: 16,

}